import { useParams } from 'react-router';
import { useArticleBody } from '@/lib/useArticleBody';
import ArticleDetail from '@components/pages/ArticleDetail';
import { STORIES, getStory } from '@/data/resources';
import { inlinedRecord } from '@/lib/inlinedRecord';
import { storyFrom } from '@/lib/siteContent';

export default function Story() {
    const { slug } = useParams();
    // As with an article: the server's copy carries this page until the feed lands.
    const inlined = inlinedRecord('stories', slug);
    const { item: story, bodyPending } = useArticleBody(
        getStory(slug) ?? (inlined ? storyFrom(inlined) : undefined),
        'stories',
    );

    return (
        <ArticleDetail
            item={story}
            bodyPending={bodyPending}
            related={STORIES.filter((s) => s.slug !== slug).slice(0, 4)}
            basePath="/resources/stories"
            backLabel="Back to Stories"
            relatedLabel="More Stories"
            kindLabel="story"
        />
    );
}
